<template>
  <header class="header">
    <div class="container">
      <app-logo></app-logo>

      <nav class="nav desktop-nav">
        <router-link class="nav-item" :to="{ name: 'kinder' }">Kindergarten</router-link>
        <router-link class="nav-item" :to="{ name: 'prof-dev' }">Professional Development</router-link>
        <router-link class="nav-item" :to="{ name: 'camps' }">Camps</router-link>
        <router-link class="nav-item" :to="{ name: 'future-explorers' }">Programs</router-link>
        <router-link class="nav-item" :to="{ name: 'resources' }">Free Resources</router-link>
        <!-- <router-link class="nav-item" :to="{ name: 'courses' }">Programs</router-link> -->
        <!-- <a class="nav-item" href="https://funacademy.fi/blog/" target="_blank">Blog</a> -->

        <div class="nav-item navbar-item has-dropdown is-hoverable" v-if="$store.state.isAuthenticated">
          <span class="navbar-link">{{
            $store.state.user ?
            (($store.state.user.firstName !== '' && $store.state.user.firstName !== null) ? $store.state.user.firstName : 'Me')
            : 'Me' }}
          </span>
          <div class="navbar-dropdown is-boxed">
            <router-link class="navbar-item" :to="{ name: 'dashboard' }">My classroom</router-link>
            <router-link class="navbar-item" :to="{ name: 'profile' }">Profile</router-link>
            <a href="javascript:void(0)" class="navbar-item" @click.prevent="logout">Log out</a>
          </div>
        </div>
        <Button v-else class="nav-item is-uppercase" size="medium" type="secondary" :to="{ name: 'login' }">Get started</Button>

      </nav>

      <nav class="nav mobile-nav">
        <span class="navbar-link mobile-menu-toggle" @click="isMobileMenuOpen = !isMobileMenuOpen">
          <div class="menu-icon" :class="{ 'open': isMobileMenuOpen }"><span></span><span></span><span></span></div>
        </span>
      </nav>

      <nav class="nav mobile-menu" :class="{ 'open': isMobileMenuOpen }">
        <router-link class="nav-item" :to="{ name: 'kinder' }">Kindergarten</router-link>
        <router-link class="nav-item" :to="{ name: 'prof-dev' }">Professional Development</router-link>
        <router-link class="nav-item" :to="{ name: 'camps' }">Camps</router-link>
        <router-link class="nav-item" :to="{ name: 'future-explorers' }">Programs</router-link>
        <router-link class="nav-item" :to="{ name: 'resources' }">Free Resources</router-link>
        <hr>
        <router-link class="nav-item" :to="{ name: 'dashboard' }">My classroom</router-link>
        <router-link class="nav-item" :to="{ name: 'profile' }">Profile</router-link>
        <a href="javascript:void(0)" class="nav-item" @click.prevent="logout">Log out</a>
      </nav>
    </div>
  </header>
</template>

<script>
import AppLogo from '@/components/AppLogo'
import Button from '@/components/Button'

export default {
  name: 'app-header',

  components: {
    AppLogo,
    Button
  },

  methods: {
    logout () {
      this.$store.dispatch('logout')
        .then(() => this.$router.push({ name: 'home' }))
    }
  },

  data () {
    return {
      isMobileMenuOpen: false
    }
  }
}
</script>

<style lang="scss">

.desktop-nav {
  display: none;

  @media screen and (min-width: 768px) {
    display: flex;
  }
}

.mobile-nav,
.mobile-menu {

  @media screen and (min-width: 768px) {
    display: none;
  }
}

.mobile-menu {
  // display: none;
  position: absolute;
  top: 60px;
  background-color: white;
  z-index: 1;
  flex-direction: column;
  width: 100%;
  text-align: center;
  box-shadow: 0 2px 6px 0 rgba(0,0,0,.15);
  opacity: 0;
  z-index: -1;
  transform: scaleY(.75);
  transform-origin: top;
  transition: .25s ease-in-out;

  .nav-item {
    display: block;
    width: 100%;
    margin-left: 0;
    text-transform: uppercase;
  }

  &.open {
    // display: block;
    opacity: 1;
    z-index: 10;
    transform: scaleY(1);
  }
}

.mobile-menu-toggle {
  height: 60px;
  display: flex;
  align-items: center;
  border-left: none;
  cursor: pointer;
}

.menu-icon {
  width: 26px;
  height: 22px;
  position: relative;
  margin: 0 auto;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: #6b7285;
    border-radius: 2px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
    transform-origin: left center;
  }

  span:nth-child(1) { top: 0; }
  span:nth-child(2) { top: 50%; transform: scaleX(1) translateY(-50%); }
  span:nth-child(3) { bottom: 0; }

  &.open span:nth-child(1) {
    transform: rotate(45deg);
  }

  &.open span:nth-child(2) {
    transform: scaleX(0) translateY(-50%);
    opacity: 0;
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/AppHeader.vue